module.exports = "https://static.wmbcdn.com/uniweb/images/f951b02f20b39df1e6fbb557d8256a3d.svg";